
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 416 448","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M195 118c0 28-14.5 61.25-46.75 61.25-40.5 0-65-51-65-86 0-28 14.5-61.25 46.75-61.25 40.75 0 65 51 65 86zm-85.5 120.75c0 24.25-12.75 49.5-40.25 49.5-40 0-69.25-49-69.25-85.25 0-24.25 13-49.75 40.25-49.75 40 0 69.25 49.25 69.25 85.5zM208 232c61.25 0 144 88.25 144 147.25C352 411 326 416 300.5 416c-33.5 0-60.5-22.5-92.5-22.5-33.5 0-62 22.25-98.25 22.25-24.25 0-45.75-8.25-45.75-36.5C64 320 146.75 232 208 232zm59.75-52.75C235.5 179.25 221 146 221 118c0-35 24.25-86 65-86 32.25 0 46.75 33.25 46.75 61.25 0 35-24.5 86-65 86zm108-26C403 153.25 416 178.75 416 203c0 36.25-29.25 85.25-69.25 85.25-27.5 0-40.25-25.25-40.25-49.5 0-36.25 29.25-85.5 69.25-85.5z"}})])
          )
        }
      }
    